import { NavLink } from "react-router-dom";
import MenuItem from "./MenuItem";

const ModuleMenu = ({ label, items, settings = null }) => {
    return (
        <div className="sb-sidenav-menu">
            <div className="nav">
                <div className="sb-sidenav-menu-heading">{label}
                    {settings && settings.permission &&

                        <NavLink className="settings-link" to={settings.to}><i className="fa-solid fa-gear"></i></NavLink>
                    }
                </div>


                {items.map((item, index) => (
                    <MenuItem key={index} {...item}>
                        {item.children && item.children.map((child, childIndex) => (
                            <MenuItem key={childIndex} {...child} />
                        ))}
                    </MenuItem>
                ))}
            </div>
        </div>
    );
};

export default ModuleMenu;